module.exports = __webpack_public_path__ + "img/flag-right.524b0423.svg";